// extracted by mini-css-extract-plugin
export default {"events-container":"EventCards_events-container__U4g-T"};